import _get from 'lodash/get';
import * as types from '../constants/ActionTypes';
import { contactMapping } from '../../lib/ContactDefaultData';
import { trackLink } from '../../lib/analytics-helper';
import { isChatBotCardOrPillPresentOnPage } from '../../lib/chat-bot-live-helper';
import { filterCallUsFromChannels, isSuppressCallUs } from '../../lib/covidHelper';
import Page from '../../lib/page';

function joinContactOptions(contactChannels = []) {
  if (!Array.isArray(contactChannels)) {
    return '';
  }

  // COVID-19 BCP suppress callUS from FPTI
  let filteredChannels = [];

  if (Page.isLoggedIn() && !Page.getIsIDIContactOptions() && isSuppressCallUs()) {
    filteredChannels = filterCallUsFromChannels(contactChannels);
  } else {
    filteredChannels = contactChannels;
  }

  const tempChannelsArr = filteredChannels.map((contactType) => {
    const temp = ((contactType && contactType.type) || '').toLocaleLowerCase();

    // Mapping contact options
    return contactMapping[temp];
  });

  return tempChannelsArr.join('|');
}

export function sendFPTIForFinalContactOptions(channels, topicRefId, selectedIntent, layer, breadCrumbs, ocpClicked) {
  const parsedChannels = joinContactOptions(channels);
  // if the final intent is arrived via ocp Prompt
  if (ocpClicked && isChatBotCardOrPillPresentOnPage()) {
    return trackLink({
      id: 'contactUsPage',
      link: `smarthelp-select-topic|prompt|${topicRefId}|final|${parsedChannels}|chatBot`,
    });
  }
  if (ocpClicked) {
    return trackLink({
      id: 'contactUsPage',
      link: `smarthelp-select-topic|prompt|${topicRefId}|final|${parsedChannels}`,
    });
  }
  // If selected Intent - which is a search intent and breadcrumbs exist
  if (selectedIntent && breadCrumbs) {
    // If chatbot card or pill exists on the page append 'chatBot' in the link.
    if (isChatBotCardOrPillPresentOnPage()) {
      return trackLink({
        id: 'contactUsPage',
        link: `smarthelp-select-topic|search|${topicRefId}|final|${parsedChannels}|chatBot`,
      });
    }
    return trackLink({
      id: 'contactUsPage',
      link: `smarthelp-select-topic|search|${topicRefId}|final|${parsedChannels}`,
    });
  }

  return topicRefId && layer > 1 && isChatBotCardOrPillPresentOnPage()
    ? trackLink({
        id: 'contactUsPage',
        link: `smarthelp-select-topic-L${layer}|${topicRefId}|final|${parsedChannels}|chatBot`,
      })
    : trackLink({
        id: 'contactUsPage',
        link: `smarthelp-select-topic-L${layer}|${topicRefId}|final|${parsedChannels}`,
      });
}

function updatedFinalContactOptions({ contactChannels, topicRefId }) {
  return {
    type: types.UPDATE_FINAL_CONTACT_OPTIONS,
    payload: {
      contactChannels,
      topicRefId,
    },
  };
}

export const updateFinalContactOptions = (contactChannels) => (dispatch, getState) => {
  const topicRefId = _get(getState(), 'selectResult.topicTreeSelectResult.topicRefId', null);
  const hasFinalContactOptions = _get(getState(), 'contactChannels.hasFinalContactOptions', null);
  const layer = _get(getState(), 'topicSelect.layer', null);
  const selectedIntent = _get(getState(), 'crawlIntentTopic.selectedIntent', null); // selected crawling topic data
  const breadCrumbs = _get(getState(), 'selectResult.topicTreeSelectResult.breadCrumbItems', null); // breadcrumb for selected data
  const ocpClicked = _get(getState(), 'ocpIntent.ocpClicked', null);
  if (!hasFinalContactOptions) {
    // sending FPTI and avoiding duplicate UI rerender to resend
    sendFPTIForFinalContactOptions(contactChannels, topicRefId, selectedIntent, layer, breadCrumbs, ocpClicked);
  }
  dispatch(updatedFinalContactOptions({ contactChannels, topicRefId }));
};

export const exportedForTesting = {
  updatedFinalContactOptions,
};
